module.exports = __webpack_public_path__ + "bbbcce33c7259be34c77037843606255.svg";